// extracted by mini-css-extract-plugin
export default {"checkboxGroup":"styles_checkboxGroup__A4aJe","selectField":"styles_selectField__tWjbK","privacyTypeRadio":"styles_privacyTypeRadio__KLznw","footer":"styles_footer__qYIzA"};